<mat-sidenav-container [ngClass]="{ 'full-height': (isLogged$ | async) === false }">
  <mat-sidenav style="z-index: 1;" *ngIf="(isLogged$ | async)" #sidenav mode="side" opened @fadeSlideInOut>
    <mat-nav-list>
      <mat-list-item *ngFor="let item of menuItems;" [routerLink]="item.path">
        <div class="col-12 d-flex ">
          <mat-icon mat-list-icon>{{item.iconName}}</mat-icon>
          <h5>{{ "MENU." + item.title | translate}}</h5>
        </div>
      </mat-list-item>
    </mat-nav-list>
    <div class="col-12 d-flex align-items-end">
      <button class="col-12 d-flex justify-content-start" mat-button (click)="logout()">
        <mat-icon>logout</mat-icon>
        <mat-label>{{ 'COMMON.LOGOUT' | translate }}</mat-label>
      </button>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="back-button d-flex p-3" *ngIf="(showBackButton$ | async) === false">
      <button mat-button (click)="goBack()">
        <mat-icon>fast_rewind</mat-icon>
        {{ 'COMMON.BACK_BUTTON' | translate }}
      </button>
    </div>
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
